import React from 'react';

const StaticImage = () => {
  return (
    <div className="w-full h-full relative overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1560439514-4e9645039924"
        alt="Professional networking"
        className="w-full h-full object-cover opacity-40"
        style={{
          filter: 'grayscale(60%)'
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to right, rgba(0,0,0,0.8), transparent)'
        }}
      />
    </div>
  );
};

export default StaticImage;